import React, {useState } from 'react';
import{ useSport } from '../../../../../context/SportContext.tsx';
import { Schedule } from '../../../../../models/Schedule.tsx';
import AlertError from '../../../../alerts/AlertError.tsx';
import { SpecialDataComponent } from './SpecialDataComponent.tsx';
import { useModal } from '../../../../../context/ModalContext.tsx';
import { BetDetails } from '../../../../../models/MyBetModel.tsx';
import { openStraightBetSlipOnSelect } from '../../../../../helpers/openBetSlipMode.tsx';

function isUpcomingSpecialGame(game: Schedule) {
    return !game.is_live && game.status === "unplayed";
}

export function SpecialData() {

    const { gameEspecial, selectedGames } = useSport();
    const [showLimitAlert, setShowLimitAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showLimit, setShowLimit] = useState<Record<string, number>>({});

    const { showModal, updateModalContent } = useModal();
    const upcomingGames = gameEspecial.filter(isUpcomingSpecialGame);

    const marketIds: string[] = Array.from(
        new Set(
            upcomingGames.flatMap((game: Schedule) =>
                game.odds?.map(o => o.market_id) ?? []
            )
        )
    );

      const onShowBetsModal = (incomingBets?: BetDetails[]) => {
        openStraightBetSlipOnSelect({
            incomingBets,
            showModal,
            updateModalContent,
            setShowLimitAlert,
            setErrorMessage,
        });
    };

    const gamesByMarket = marketIds.map((marketId) => {
        const filteredGames = upcomingGames
            .map((game: Schedule) => ({
                ...game,
                odds: game.odds?.filter(o => o.market_id === marketId) ?? []
            }))
            .filter((game: Schedule) => game.odds.length > 0);

        return {
            marketId,
            games: filteredGames
        };
    });

    // Still list matchups that came back without odds for the selected market.
    const gamesWithoutOdds = upcomingGames.filter(game => !game.odds?.length);

    const hasGames =
        gamesByMarket.some(m => m.games.length > 0) ||
        gamesWithoutOdds.length > 0;

    if (!selectedGames) return null;

    return (
        <>
            {!hasGames && selectedGames && (
                <div className="no-data-games">
                    There are currently no odds available for this league.
                </div>
            )}
            {hasGames && (
                <div className="containertable">
                    {gamesByMarket.map(({ marketId, games }) => {
                        if (!games.length) return null;
                        return (
                            <div key={marketId}>
                                {games.map((game: Schedule) => (
                                    <SpecialDataComponent
                                        key={`${marketId}-${game.game_id}`}
                                        game={game}
                                        marketId={marketId}
                                        showLimit={showLimit}
                                        setShowLimit={setShowLimit}
                                        onShowBetsModal={onShowBetsModal}
                                        setErrorMessage={setErrorMessage}
                                    />
                                ))}
                            </div>
                        );
                    })}
                    {gamesWithoutOdds.map((game: Schedule, index: number) => (
                        <SpecialDataComponent
                            key={`no-odds-${game.leagueKey ?? "market"}-${game.game_id ?? game.id ?? index}`}
                            game={game}
                            marketId=""
                            showLimit={showLimit}
                            setShowLimit={setShowLimit}
                            onShowBetsModal={onShowBetsModal}
                            setErrorMessage={setErrorMessage}
                        />
                    ))}
                </div>
            )}




            {showLimitAlert && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setShowLimitAlert(false)}
                />
            )}
            {errorMessage && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setErrorMessage("")}
                />
            )}
        </>
    )
}
